import React, { useState } from 'react';

// Datos mock de ventas no instaladas o sin código de cliente
const ventasMock = [
  { id: 1, cliente: 'Pedro Gómez', producto: 'Internet 100Mb', estado: 'NO INSTALADO', fecha: '2024-06-01', codigoCliente: null },
  { id: 2, cliente: 'Lucía Torres', producto: 'TV HD', estado: 'PENDIENTE', fecha: '2024-06-02', codigoCliente: '', },
  { id: 3, cliente: 'Carlos Ruiz', producto: 'Internet 200Mb', estado: 'NO INSTALADO', fecha: '2024-06-03', codigoCliente: null },
];

const estados = ['NO INSTALADO', 'PENDIENTE', 'INSTALADO', 'ANULADO'];

const BackRecuperoPanel = () => {
  const [ventas, setVentas] = useState(ventasMock);

  const handleEstadoChange = (id, nuevoEstado) => {
    setVentas(ventas.map(v => v.id === id ? { ...v, estado: nuevoEstado } : v));
  };

  return (
    <div style={{marginLeft:280, padding:'32px 24px', minHeight:'80vh', background:'#f8fafc'}}>
      <h2 style={{fontSize:'2.2rem',fontWeight:900,color:'#1a237e',marginBottom:32,textAlign:'center'}}>Panel Back Recupero</h2>
      <div style={{background:'#fff',borderRadius:16,boxShadow:'0 2px 16px rgba(124,58,237,0.08)',padding:24,maxWidth:1000,margin:'0 auto'}}>
        <h3 style={{color:'#7c3aed',fontWeight:700,marginBottom:12}}>Ventas no instaladas o sin código de cliente</h3>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead>
            <tr style={{background:'#f3f4f6'}}>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Cliente</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Producto</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Estado</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Fecha</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Código Cliente</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Actualizar Estado</th>
            </tr>
          </thead>
          <tbody>
            {ventas.map(v => (
              <tr key={v.id}>
                <td style={{padding:'8px'}}>{v.cliente}</td>
                <td style={{padding:'8px'}}>{v.producto}</td>
                <td style={{padding:'8px'}}>{v.estado}</td>
                <td style={{padding:'8px'}}>{v.fecha}</td>
                <td style={{padding:'8px'}}>{v.codigoCliente || <span style={{color:'#f43f5e'}}>Sin código</span>}</td>
                <td style={{padding:'8px'}}>
                  <select value={v.estado} onChange={e => handleEstadoChange(v.id, e.target.value)} style={{padding:'6px 10px',borderRadius:6,border:'1.5px solid #d1d5db',color:'#1a237e'}}>
                    {estados.map(e => <option key={e} value={e}>{e}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BackRecuperoPanel; 